import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { genieMeetingService } from "@/services/agent/GenieMeetingService";
import { AdminGenieMeetingFilters } from "@/types/agent/genie-meeting";

export const ADMIN_MEETINGS_PAGE_SIZE = 50;

export const useAdminGenieMeetings = (filters: AdminGenieMeetingFilters, page: number) =>
  useQuery({
    queryKey: ["admin-genie-meetings", filters, page],
    queryFn: () =>
      genieMeetingService.adminList(filters, ADMIN_MEETINGS_PAGE_SIZE, (page - 1) * ADMIN_MEETINGS_PAGE_SIZE),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
